
import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

export const useStyles = makeStyles(() => ({
    textContainer: {
        width: '100%',
        overflow: 'hidden',
        display: 'inline-block',
        'box-sizing': 'border-box',
        'white-space': 'pre-line',
        'word-wrap': 'break-word',
     
        '& .typography-text-box': {
            display: '-webkit-box',
            '-webkit-box-orient': 'vertical',
            '-webkit-line-clamp': 2,
            'line-clamp': 2,
            overflow: 'hidden',
        },
    },

    copyButton: {
        'min-width': '105px'
    },
   
    textRightAlign: {
        width: '100%',
    },
    contentBox: {
        'margin-top': '24px',
        'margin-bottom': '24px',
        width: '100%'
    }
  }));

  export const CopyBox = styled.div<{ isMobile: boolean }>`
    display: flex;
    justify-content: ${({isMobile}) => (isMobile ? 'center' : 'space-between')};
    width: 100%;
    gap: 16px;
    margin-top: 24px;
    align-items: center;
    margin-bottom: 44px;
    flex-direction: ${({isMobile}) => (isMobile ? 'column' : 'row')};
`

export const ButtonsBox = styled.div<{ isMobile: boolean }>`
    display: flex;
    gap: 16px;
    margin-top: 24px;
    width: 100%;
    flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
    justify-content: ${({ isMobile }) => (isMobile ? 'center' : 'flex-end')};
    align-items: center;
`;